<ng-container *ngIf="state$ | async as state">
  <div aria-label="Main"
       class="navigation"
       data-cy="navigation-categories"
       id="navbar"
       role="navigation"
  >
    <ul [attr.data-filtered]="!!(selectedCategory$ | async) ? 1 : 0"
        class="nav navbar-nav"
        data-cy="navigation-categories-list"
    >
      <li *ngFor="let category of navigation$ | async; index as i"
          [class.is-open]="(selectedCategory$ | async)?.id === category?.id"
          data-cy="navigation-categories-list-item"
          class="level1"
      >
        <mb-link [dataEventAction]="'Click ' + category?.label"
                 [dataTarget]="category?.label"
                 [linkData]="{uid: cmsLinkType.SPECIAL, text: category?.label}"
                 (clickEvent)="categoryClick.emit({ category, event: $event })"
                 styleClass="category-link"
                 dataEventCategory="TopNavi"
        ></mb-link>
      </li>
    </ul>
  </div>
</ng-container>
